import BaseService from './base.service';

export default class SettingService {
  private apiService: any;

  constructor() {
    this.apiService = new BaseService();
  }

  public getSessions() {
    return this.apiService.get('accounts-api/sessions-list-api/');
  }

  public deleteSessionById(data: any) {
    return this.apiService.post('accounts-api/sessions-delete-api/', data);
  }

  public deleteAllSessions() {
    return this.apiService.post('accounts-api/sessions-delete-all-api/ ');
  }

  public getUserSessions() {
    return this.apiService.get('user_sessions/session/api/');
  }

  public getSecurity() {
    return this.apiService.get('security-api/');
  }

  public getUserSecurity() {
    return this.apiService.get('user-security-api/');
  }

  public getUserActivity() {
    return this.apiService.get('user-activity-api/');
  }

  public getUserFilterActivity(data: any){
    return this.apiService.post('user-activity-api/', data);
  }

  public getUserActivityServerSidePagination(query: any){
    return this.apiService.post('user-activity-api/', query);
  }

  public getQrString() {
    return this.apiService.get('mfa/user-qr-string-api/');
  }

  public mfaFlasgSet() {
    return this.apiService.get('mfa/mfa-flag-api/');
  }
  public UpdateMfa(data: any) {
    return this.apiService.post('mfa/user-qr-string-api/', data);
  }
  public DisableMfa() {
    return this.apiService.get('mfa/disable-mfa/');
  }
  public UserList() {
    return this.apiService.get('mfa/list-all-users/');
  }
  public deleteMfaById(data:any){
    return this.apiService.post('mfa/mfa-reset/', data);
  }
  public enableMfaById(data:any){
    return this.apiService.post('mfa/enable-mfa/', data);
  }
  public disableMfaById(data:any){
    return this.apiService.post('mfa/disable-mfa-by-id/', data);
  }
  public GmailAuth(data:any){
    return this.apiService.post('accounts-api/gmail-auth/', data);
  }
  public GetGmailAuth(){
    return this.apiService.get('accounts-api/gmail-auth/');
  }
}

